import { ThemeColor, ValidationAction, Vehicle } from "../../../system/Domain";
import Tile from "../../../Components/Tiles/Tile";
import TileContent from "../../../Components/Tiles/TileContent";
import TextGroup from "../../VehicleSales/TextGroup";
import TextLine from "../../VehicleSales/TextLine";
import formatDateTime from "../../../system/formatDateTime";
import { Fragment } from "react";

const formatValidationHistoryAction = (action: ValidationAction) => {
	switch (action) {
		case "InitialSave":
			return "Initiale Bearbeitung";
		case "Update":
			return "Update";
		case "Transfer":
			return "Leasmanübertragung";
		case "TransferFailed":
			return "Übertragungsfehler";
		case "TransferLeasmanOnly":
			return "Leasmanübertragung (ohne Nebeneffekte)";
		case "TransferLeasmanOnlyFailed":
			return "Leasmanübertragung fehlgeschlagen (ohne Nebeneffekte)";
		case "StopAdded":
			return "Validationsstopp hinzugefügt";
		case "StopResolved":
			return "Validationsstopp aufgelöst";
		case "ValidationDocumentUpload":
			return "Upload - Validationsdokument"
		case "ValidationDocumentDmsUpload":
			return "DMS Upload - Validationsdokument";
		case "NotificationResent":
			return "E-Mail erneut gesendet";
		default:
			return action;
	}
};

const paintValidationHistoryAction = (action: ValidationAction): ThemeColor => {
	switch (action) {
		case "TransferFailed":
		case "TransferLeasmanOnlyFailed":
			return "error";
		case "Reset":
			return "warning";
		case "InitialSave":
		case "ValidationDocumentUpload":
		case "ValidationDocumentDmsUpload":
		case "Update":
			return "primary";
		case "Transfer":
		case "TransferLeasmanOnly":
			return "success";
		default:
			return "info";
	}
};

interface Props {
	vehicle: Vehicle
}

const ValidationStatusHistoryTile = (props: Props) => {
	if (!props.vehicle?.remarketing?.validation?.history) {
		return null;
	}

	return (
		<Tile title="Statushistorie" sxProp={{ mb: 2 }}>
			<TileContent>
				<TextGroup>
					{[...props.vehicle.remarketing.validation.history].reverse().map((h, i) => (
						<Fragment key={i}>
							<TextLine
								label={formatDateTime(h.date)}
								value={formatValidationHistoryAction(h.action)}
								color={paintValidationHistoryAction(h.action)}
							/>
							{h.user && <TextLine label="" value={h.user.name} />}
							{h.message && <TextLine label="" value={h.message} />}
						</Fragment>
					))}
				</TextGroup>
			</TileContent>
		</Tile>
	);
};

export default ValidationStatusHistoryTile;
